'use strict';

function buildScarcityHtml() {
	return (
		'<p class="product-scarcity" role="status" aria-live="polite">' +
		'<i class="icon-fire-4 product-scarcity__icon" aria-hidden="true"></i>' +
		'<span class="product-scarcity__text"></span>' +
		'</p>'
	);
}

function syncExistingScarcityTargets($targets, $root, scarcity, html) {
	$targets.each(function () {
		let $el = $(this);
		if (!$el.find('.product-scarcity__text').length) {
			$el.replaceWith(html);
			$el = $root.find('.product-scarcity').last();
		}
		$el.find('.product-scarcity__text').text(scarcity.message);
		$el.toggle(!!scarcity.message);
	});
}

function insertScarcityNearQuantity($root, scarcity, html) {
	let $anchor = $root.find('.product-tile__qty-atc').first();
	if (!$anchor.length) {
		$anchor = $root.find('.product-qty-wrap').first();
	}
	if (!$anchor.length) {
		return;
	}

	let $inserted = $(html);
	$inserted.find('.product-scarcity__text').text(scarcity.message);
	if ($anchor.hasClass('product-tile__qty-atc')) {
		$anchor.after($('<div class="product-tile__scarcity"></div>').append($inserted));
	} else {
		$anchor.after($inserted);
	}
}

/**
 * Syncs scarcity message markup after Ajax product updates (PLP tile / PDP variation).
 *
 * @param {Object} product - Product model from Product-Variation JSON.
 * @param {jQuery} $root - Container to scope DOM updates.
 */
function updateScarcity(product, $root) {
	if (!$root || !$root.length) {
		return;
	}

	let scarcity = product && product.scarcity ? product.scarcity : null;
	let show = !!(scarcity && scarcity.show && scarcity.message);
	let $targets = $root.find('.product-scarcity');

	if (!$targets.length && $root.hasClass('product-scarcity')) {
		$targets = $root;
	}

	if (!show) {
		$targets.remove();
		return;
	}

	let html = buildScarcityHtml();
	syncExistingScarcityTargets($targets, $root, scarcity, html);

	if (!$targets.length) {
		insertScarcityNearQuantity($root, scarcity, html);
	}
}

module.exports = {
	updateScarcity: updateScarcity,
};
